module.exports = __webpack_public_path__ + "static/media/2022__K8A0110.09da5ce4.jpg";